// components/ActionRequiredTableRow.tsx
import { FC, useContext } from "react";
import { Link } from "react-router-dom";
import { TodoDataProps } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";
import { format } from "date-fns";
import { AuthContext } from "src/context/authContext";

interface Props {
  data: TodoDataProps;
  refreshListing: () => void;
}

const ActionRequiredTableRow: FC<Props> = ({ data,refreshListing }) => {
  
  const { isManufacturer } = useContext(AuthContext);
  const formatDate = (date: string) => (date ? format(new Date(date), "MM/dd/yyyy") : "");
  


  return (
  <tr>
    {/* Patient Name */}
    <td className="text-center align-middle">
      {data.patient_name !== "Redacted" ? (
        <Link to={`/global_patients/${data.patient_id}`}>
          {data.patient_name}
        </Link>
      ) : (
        data.patient_name
      )}
    </td>

    {/* Patient ID */}
    <td className="text-center align-middle">
      <Link 
        to={`/global_patients/${data.patient_id}`}
        className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
      >
        {data.patient_id}
      </Link>
    </td>

    {/* Case ID */}
    <td className="text-center align-middle">
      <Link 
        to={`/cases/detail/${data.bi_case_id}`}
        className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
      >
        {data.bi_case_id}
      </Link>
    </td>

    {/* Reverification */}
    <td className="text-center align-middle">
      {data.drug_name}
    </td>
     {/* <td className="text-center align-middle">
      {data.reverification && (
        <span className={`${data.reverification.toLowerCase() === "new" ? "" : ""}`}>
          {data.reverification}
        </span>
      )}
    </td> */}


    {/* Date Completed */}
    <td className="text-center align-middle">
      {isManufacturer ? formatDate(data.bi_completed) : data.bi_completed}
    </td>

    {/* Insurance/Payer */}
    <td className="text-center align-middle">
      {isManufacturer ? data.payer : data.insurance_type}
    </td>

    {/* Physician */}
    <td className="text-center align-middle">{data.physician}</td>

    {/* Medical Coverage */}
    <td className="align-middle">
        <span className={`badge ${data.medical_coverage_status_color !== 5 ? "text-white" : ""} background-color-${data.medical_coverage_status_color}`}>
            {data.medical_coverage_status}
        </span>
    </td>
    {/* <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>
    </td> */}

    {/* Pharmacy Coverage */}
    <td className="align-middle">
        <span className={`badge ${data.pharmacy_coverage_status_color !== 5 ? "text-white" : ""} background-color-${data.pharmacy_coverage_status_color}`}>
            {data.pharmacy_coverage_status}
        </span>
    </td>
    <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>

    </td>
  </tr>
);
}
  

export default ActionRequiredTableRow;
